import { render, staticRenderFns } from "./EmblemEditor.vue?vue&type=template&id=56fac06a&"
import script from "./EmblemEditor.vue?vue&type=script&lang=js&"
export * from "./EmblemEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmblemEditor.vue?vue&type=style&index=0&id=56fac06a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports